import t from '@jetshop/intl';
import PropTypes from 'prop-types';
import React from 'react';
// import { SVG } from '../../../../assets/SVG';
import StockOrb from './StockOrb';

const StockStatusIndicator = ({ status, text, ...props }) => (
  <div className="stock-status-indicator">
    <span className="title">{t('Stock online')}:</span>
    <span>{text}</span>

    <div className="icon">
      {/* {status === 'inStock' ? <SVG name="PDPCheck" /> : <SVG name="PDPCross" />} */}
      <StockOrb
        status={status == 'inStock' && text.length > 10 ? 'inComing' : status}
      />
    </div>
  </div>
);

StockStatusIndicator.propTypes = {
  status: PropTypes.oneOf([
    'inStock',
    'outOfStock',
    'notifyWhenBack',
    'fewInStock',
    'inComing'
  ]),
  text: PropTypes.string
};

export default StockStatusIndicator;
